import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class RefreshService {
  refresh: BehaviorSubject<any> = new BehaviorSubject(null);
  constructor() { }
}
